// wait for expand transition set in vuetify variable $primary-transition; default = 0.3
import { VUETIFY_TRANSITION_DURATION } from '@/constants/common';

function isElementInViewport (el) {
  const rect = el.getBoundingClientRect();
  const vWidth = window.innerWidth || document.documentElement.clientWidth;
  const vHeight = window.innerHeight || document.documentElement.clientHeight;
  const efp = function (x, y) { return document.elementFromPoint(x, y); };

  // Return false if it's not in the viewport
  if (rect.right < 0 || rect.bottom < 0 ||
    rect.left > vWidth || rect.top > vHeight) { return false; }

  // Return true if any of its four corners are visible
  return (
    el.contains(efp(rect.left, rect.top)) ||
    el.contains(efp(rect.right, rect.top)) ||
    el.contains(efp(rect.right, rect.bottom)) ||
    el.contains(efp(rect.left, rect.bottom))
  );
}

export const scrollToViewport = {
  inserted (el) {
    const observer = new MutationObserver(function () {
      // wait for vuetify transition
      setTimeout(() => {
        const height = Number.parseInt(el.style.height);

        if (height > 0 && !isElementInViewport(el)) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, VUETIFY_TRANSITION_DURATION);
    });

    // watch for attributes mutation
    observer.observe(el, { attributes: true, attributeFilter: ['style'] });
  },
};
